import { createAsyncThunk } from "@reduxjs/toolkit";

export const manageLsrVorItemConnection = createAsyncThunk(
	"lsrVor/manageLsrVorItemConnection",
	async ({ projectId, action }, { rejectWithValue, extra, getState }) => {
		try {
			const lsrId = getState().lsrVor.selectedLsr?.id;
			const lsrItemId = getState().lsrVor.selectedLsrItem?.id;
			const vorId = getState().lsrVor.selectedVor?.id;
			const vorItemId = getState().lsrVor.selectedVorItem?.id;

			const multiSelectedLsrItem = getState().lsrVor.multiSelectedLsrItems;
			const multiSelectedLsrItemIds = multiSelectedLsrItem.map((x) => x.id);

			const multiSelectedVorItem = getState().lsrVor.multiSelectedVorItems;
			const multiSelectedVorItemIds = multiSelectedVorItem.map((x) => x.id);

			let lsrItemIds = [];
			let vorItemIds = [];

			if (multiSelectedLsrItemIds?.length > 0) {
				lsrItemIds = multiSelectedLsrItemIds;
				if (lsrItemId && !multiSelectedLsrItemIds?.includes(lsrItemId)) {
					lsrItemIds = [lsrItemId, ...multiSelectedLsrItemIds];
				} else {
					lsrItemIds = multiSelectedLsrItemIds;
				}
			} else {
				lsrItemIds = [lsrItemId];
			}

			if (multiSelectedVorItemIds?.length > 0) {
				vorItemIds = multiSelectedVorItemIds;
				if (vorItemId && !multiSelectedVorItemIds?.includes(vorItemId)) {
					vorItemIds = [vorItemId, ...multiSelectedVorItemIds];
				} else {
					vorItemIds = multiSelectedVorItemIds;
				}
			} else {
				vorItemIds = [vorItemId];
			}

			const body = {
				action: action,
				lsr_id: lsrId,
				lsr_item_ids: lsrItemIds,
				vor_id: vorId,
				vor_item_ids: vorItemIds,
			};

			const { data } = await extra.apiLsrVor.manageLsrVorItemConnection({ projectId, body });

			if (!data) {
				throw new Error();
			}

			return data;
		} catch (e) {
			return rejectWithValue(e);
		}
	}
);
